import api from '@/utils/api'

export default {
    login(data) {
        return api.post(`webchat/login`, data)
    },

    currentUser() {
        const authHeader = { 'Authorization': 'Bearer ' + localStorage.getItem('mpass-web-widget-chat-token') }
        return api.request(`webchat/current-user`, 'GET', authHeader, null)
    },

    getPersistentMenu() {
        return api.get(`template-configs/persistent-menus/available`)
    },

    getGetStarted() {
        return api.get(`template-configs/get-started/available`)
    },

    getTheming() {
        return api.get(`theming-configs/available`)
    }
}